export enum UserRole {
  Owner = 'owner',
  Admin = 'administrator',
  User = 'user'
}

export type UserRoleString = `${UserRole}`
